import styled from 'styled-components';

export const ProjectsDropdownContainer = styled.div`
  width: 100%;
`;
